import { Component, Inject, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuditInterface } from 'src/app/audit/model/Audit.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { untilDestroyed } from 'ngx-take-until-destroy';

@Component({
  selector: 'app-detail-modal',
  templateUrl: './detail-modal.component.html',
  styleUrls: ['./detail-modal.component.scss']
})
export class DetailModalComponent implements OnInit {
  @Input()
  audit: AuditInterface;

  @Input()
  display: boolean;

  type(value: any): string {
    return typeof value;
  }

  ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this)).subscribe((data: { event: AuditInterface }) => {
      this.audit = this.data;
    });
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialogRef: MatDialogRef<DetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnDestroy(): void { }
}